import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';

// Same pricing as before
const PRICE_LIST = {
  'Accounts': 3,
  'Arts and Humanities': 2,
  'Economics': 2,
  'Engineering': 4,
  'Computer Science': 3.5,
  'Law': 3,
  'Management': 2,
  'Nursing': 3,
  'Business': 3 // Adjust if needed
};

const TaskDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [instructions, setInstructions] = useState('');
  const [wordCount, setWordCount] = useState('');
  const [fileName, setFileName] = useState('');

  if (!state) {
    return (
      <div className="min-h-screen bg-[#02042b] flex items-center justify-center">
        <p className="p-8 text-center text-white">
          No task information found.{' '}
          <Link to="/checkout/order-details" className="text-yellow-400 underline">
            Go back
          </Link>
        </p>
      </div>
    );
  }

  const {
    assignmentType,
    subject,
    deadline,
    firstDraft,
  } = state;

  // Calculate price per word and total price
  const pricePerWord = PRICE_LIST[subject] || 0;
  const totalPrice = wordCount ? pricePerWord * Number(wordCount) : 0;
  const finalPrice = firstDraft ? Math.round(totalPrice * 1.05) : totalPrice; // +15% if draft requested

  // Fix here: Get first file from FileList on change
  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setFileName(files[0].name);
    } else {
      setFileName('');
    }
  };

  const handleNext = () => {
    if (!wordCount || isNaN(wordCount)) {
      alert("Please enter a valid word count.");
      return;
    }
    const pages = Math.ceil(Number(wordCount) / 300);
    navigate('/specialist', {
      state: {
        ...state,
        instructions,
        wordCount,
        pages,
        fileName,
        pricePerWord,
        totalPrice: finalPrice
      }
    });
  };

  const computedPages = wordCount ? Math.ceil(Number(wordCount) / 300) : '';

  return (
    <div className="min-h-screen bg-[#02042b] py-16 mt-12">
      <div className="max-w-6xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-white mb-4">
          Outline Your Task Details
        </h1>
        <p className="text-center text-lg text-gray-300 mb-8">
          (Share extra instructions, upload files, and set your word/page count)
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-6 shadow-lg space-y-6">
            <div>
              <label className="block text-gray-800 font-semibold mb-2">Instructions</label>
              <textarea
                value={instructions}
                onChange={(e) => setInstructions(e.target.value)}
                rows={4}
                className="w-full border border-gray-300 rounded-lg p-3"
                placeholder="Provide clear guidelines, key points, and any specific requirements for your assignment."
              />
            </div>

             <div>
              <label className="block text-gray-800 font-semibold mb-2">Google Drive Link of Your Pdf</label>
              <textarea
                value={fileName}
                onChange={(e) => setFileName(e.target.value)}
                rows={1}
                className="w-full border border-gray-300 rounded-lg p-3"
                placeholder="**Pdf file Acess type  Should be Everyone** "
              />
            </div>

            <div>
              <label className="block text-gray-800 font-semibold mb-2">Set Word Count</label>
              <input
                type="number"
                value={wordCount}
                onChange={(e) => setWordCount(e.target.value)}
                placeholder="e.g. 3000"
                className="w-full border border-gray-300 rounded-lg p-3"
                min={1}
              />
              <p className="text-sm text-gray-500 mt-1">(300 words = 1 page)</p>
            </div>

            <div className="flex justify-between">
              <button
                onClick={() => navigate(-1)}
                className="px-6 py-2 rounded-lg border border-gray-300 text-[#373057]"
              >
                ← Back
              </button>
              <button
                onClick={handleNext}
                className="px-6 py-2 bg-[#373057] text-white rounded-lg"
              >
                Next
              </button>
            </div>
          </div>

          {/* Summary Card */}
          <div>
            <div className="flex justify-end mb-4">
              <button className="px-6 py-2 rounded-full bg-[#1f2937] text-white font-medium">
                Order Information
              </button>
            </div>
            <div className="bg-white rounded-3xl p-6 shadow-xl relative">
              <div className="absolute top-4 right-4 flex flex-col items-center">
                <div className="h-10 w-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold">
                  ✓
                </div>
                <div className="h-16 border-r-4 border-orange-500 my-1" />
                <div className="h-10 w-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold">
                  2
                </div>
              </div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                Provide your order details
              </h2>
              <p className="text-gray-600 mb-1">
                <strong>Assignment Type:</strong> {assignmentType}
              </p>
              <p className="text-gray-600 mb-1">
                <strong>Subject:</strong> {subject}
              </p>
              <p className="text-gray-600 mb-1">
                <strong>Deadline:</strong> {deadline}
              </p>
              <p className="text-gray-600 mb-1">
                <strong>First Draft:</strong> {firstDraft ? 'Included (+15%)' : 'No'}
              </p>
              
              <p className="text-gray-600 mt-4">
                <strong>Word Count:</strong> {wordCount || '–'} / <strong>Pages:</strong> {computedPages || '–'}
              </p>
              <p className="text-gray-800 mt-4 font-semibold">
                Price Per Word: {pricePerWord ? `${pricePerWord} INR` : '–'}
              </p>
              {wordCount && (
                <>
                  <p className="text-gray-800 font-bold">
                    Total Price: {finalPrice} INR
                  </p>
                  {firstDraft && (
                    <p className="text-gray-600 text-sm">
                      (Includes +15% for first draft)
                    </p>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskDetails;
